// extracted by mini-css-extract-plugin
export default {"image":"LZhph1","placeholder":"Nu4Nbk"};